var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInviteUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0016 4.90156C12.0803 4.90156 8.90156 8.08034 8.90156 12.0016C8.90156 15.9228 12.0803 19.1016 16.0016 19.1016C19.9228 19.1016 23.1016 15.9228 23.1016 12.0016C23.1016 8.08034 19.9228 4.90156 16.0016 4.90156ZM7.10156 12.0016C7.10156 7.08623 11.0862 3.10156 16.0016 3.10156C20.9169 3.10156 24.9016 7.08623 24.9016 12.0016C24.9016 16.9169 20.9169 20.9016 16.0016 20.9016C11.0862 20.9016 7.10156 16.9169 7.10156 12.0016Z",
    fill: "#383733"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9993 20.9016C13.6996 20.9015 11.4403 21.5067 9.44854 22.6563C7.45675 23.8058 5.80254 25.4593 4.6521 27.4506C4.40345 27.881 3.85297 28.0283 3.42258 27.7797C2.99219 27.531 2.84486 26.9806 3.09351 26.5502C4.40197 24.2854 6.2834 22.4048 8.54878 21.0973C10.8142 19.7898 13.3837 19.1015 15.9993 19.1016C18.6149 19.1016 21.1845 19.7899 23.4498 21.0974C25.7152 22.405 27.5966 24.2856 28.905 26.5504C29.1536 26.9808 29.0063 27.5313 28.5759 27.7799C28.1455 28.0286 27.595 27.8812 27.3464 27.4509C26.196 25.4595 24.5418 23.806 22.55 22.6564C20.5583 21.5068 18.299 20.9016 15.9993 20.9016Z",
    fill: "#383733"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteUser);
export default __webpack_public_path__ + "static/media/inviteUser.e45eb9762e1c008805b8823986c4ca04.svg";
export { ForwardRef as ReactComponent };